/* eslint-disable no-nested-ternary */
import Graphic from "@arcgis/core/Graphic";
/**
 *
 * @param {array} dataArr - array of regions data with geometry
 * @param {object} view - view object
 * @param {object} graphicsLayer - graphics layer object
 */
export default function handleZoom(dataArr, view, graphicsLayer) {
  // const greenMarker = {
  //   type: "simple-marker",
  //   outline: { join: "round", width: 1, color: [0, 255, 0, 0.8] },
  //   size: 7,
  // };
  // const blueMarker = {
  //   type: "simple-marker",
  //   outline: { join: "round", width: 1, color: [0, 0, 255, 0.8] },
  //   size: 7,
  // };
  const redMarker = {
    type: "simple-marker",
    outline: { join: "round", width: 1, color: [255, 0, 0, 0.8] },
    size: 7,
  };

  const polygonMarker = {
    type: "simple-fill",
    outline: { width: 2, color: [255, 255, 255, 1] },
    color: [0, 0, 0, 0],
  };

  const handleMarker = (obj) => {
    let marker;
    if (obj.Category) {
      if (obj.Category === "30 Watt") marker = redMarker;
      if (obj.Category === "40 Watt") marker = redMarker;
      if (obj.Category === "70 Watt") marker = redMarker;
    } else {
      marker = polygonMarker;
    }
    return marker;
  };

  const centroidData = dataArr.map(
    (dataObj) =>
      new Graphic({
        attributes: { ...dataObj },
        geometry: dataObj.geometry,
        symbol: handleMarker(dataObj),
      })
  );

  graphicsLayer?.removeAll();
  graphicsLayer?.addMany(centroidData);
  view.goTo(centroidData);
}
